import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Truncate from 'react-truncate'
import { Tooltip } from 'react-tippy'
import ToolTipContent from './ToolTipContent'
import { capitalize } from '../../../../../../utils/string'
import * as diploma from '../../../../../../assets/wheel_icons/diploma.svg'
import * as briefcase from '../../../../../../assets/wheel_icons/briefcase.svg'
import * as rightArrow from '../../../../../../assets/wheel_icons/rightArrow.svg'

export default class MilestoneItem extends Component {
  static propTypes = {
    milestone: PropTypes.any.isRequired,
    arrow: PropTypes.bool,
    isMobile: PropTypes.bool,
  }
  static defaultProps = {
    arrow: true,
  }

  render() {
    const {
      milestone,
      milestone: { company_or_university, is_target, milestone_title, type },
      isMobile,
      arrow,
    } = this.props
    const edu = type === 'education'
    let title = milestone_title ? milestone_title : ''
    // if (edu) {
    //   if (level && level !== '' && major && major !== '') title = `${capitalize(level)} of ${capitalize(major)}`
    //   else if ((!level || level ==='') && major && major !== '') title = capitalize(major)
    // }

    return (
      <div style={{ display: 'inline-block', width: 115, userSelect: 'none' }}>
        <div className="row m-0">
          {arrow && (
            <div style={{ marginTop: '25%' }}>
              <img src={rightArrow} style={{ width: 15 }} alt="right arrow" />
            </div>
          )}

          <Tooltip
            html={<ToolTipContent milestone={milestone} isMobile={isMobile} />}
            sticky
            arrow
            position="top-end"
            trigger="mouseenter focus"
          >
            <div style={{ cursor: 'pointer' }}>
              <div style={{ width: 100 }}>
                <div
                  className="shadow"
                  style={{
                    width: '60%',
                    margin: '0 auto',
                    borderRadius: '50%',
                    padding: 8,
                    border: '1px solid #ecf0fc',
                    backgroundColor: 'white',
                    textAlign: 'right',
                  }}
                >
                  {!!is_target && (
                    <i
                      className="fas fa-circle"
                      style={{
                        color: '#EE6352',
                        display: 'block',
                        marginBottom: -15,
                        marginRight: -15,
                      }}
                    />
                  )}
                  <img
                    src={edu ? diploma : briefcase}
                    style={{ margin: '0 auto', display: 'block' }}
                    alt=""
                  />
                </div>
                <div
                  style={{
                    fontSize: 11,
                    textAlign: 'center',
                    padding: 3,
                    whiteSpace: 'initial',
                    userSelect: 'none',
                  }}
                >
                  <Truncate lines={2}>
                    {!title || title === 'Unspecified'
                      ? capitalize(company_or_university)
                      : capitalize(title)}
                  </Truncate>
                </div>
              </div>
            </div>
          </Tooltip>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/Pathways/MilestoneItem.js